import { render } from "./EditContactForm.vue?vue&type=template&id=0ec768cf"
import script from "./EditContactForm.vue?vue&type=script&lang=js"
export * from "./EditContactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__